import script from "./Articles.vue?vue&type=script&setup=true&lang=js"
export * from "./Articles.vue?vue&type=script&setup=true&lang=js"

import "./Articles.vue?vue&type=style&index=0&id=56c7496c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56c7496c"]])

export default __exports__